import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=470f1298&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('470f1298')) {
      api.createRecord('470f1298', component.options)
    } else {
      api.reload('470f1298', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=470f1298&", function () {
      api.rerender('470f1298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QiTxy0Jx880e/JS/comp/ImgFallback.vue"
export default component.exports